import React from 'react';
import { Alert, Button, Spin } from 'antd';

export function CustomerProfileState({ state, onRetry }) {
  if (!state || ['idle', 'ready'].includes(state.status)) return null;
  if (state.status === 'loading') return <div role="status" style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Spin size="small" />Loading customer details…</div>;
  return <Alert showIcon type={state.status === 'error' ? 'error' : 'warning'} message={state.message}
    action={state.retryable && onRetry ? <Button size="small" onClick={onRetry}>Retry customer details</Button> : undefined} />;
}
